import { ref, readonly } from 'vue';
import { copy } from '@/helpers/utilities';
import { getItemKeyByType } from '@/helpers/tile';

const state = ref({
    course: null,
    activeItemIndex: -1
});

const setCourse = course => {
    state.value.course = { ...(state.value.course || {}), ...course };
};

const setScreen = (screenId, screen) => {
    if (!state.value.course) return;
    const screenIndex = state.value.course.screens.findIndex(screen => screen.id === screenId);
    if (screenIndex === -1) return;
    
    const unchanged = copy(state.value.course.screens[screenIndex]);
    const updated = { ...state.value.course.screens[screenIndex], ...screen };
    if (JSON.stringify(unchanged) === JSON.stringify(updated)) return false;

    state.value.course.screens.splice(screenIndex, 1, updated);
};

const setScreenItem = (_screen, itemIndex, item) => {
    if (!state.value.course) return;
    const screenIndex = state.value.course.screens.findIndex(s => _screen.id ?s.id === _screen.id : s.sequence === _screen.sequence);
    if (screenIndex === -1) return;
    const screen = state.value.course.screens[screenIndex];
    const type = screen.type.name;
    
    const itemKey = getItemKeyByType(type);
    if (type !== 'quiz' && !screen.object[itemKey]) return;
    if (type === 'quiz' && !screen.questions) return;
    const unchanged = type === 'quiz' ? copy(screen.questions[itemIndex]) : copy(screen.object[itemKey][itemIndex]);
    const updated = type === 'quiz' ? { ...screen.questions[itemIndex], ...item } : { ...screen.object[itemKey][itemIndex], ...item };
    if (JSON.stringify(unchanged) === JSON.stringify(updated)) return false;
    
    if (type === 'quiz') {
        state.value.course.screens[screenIndex].questions.splice(itemIndex, 1, updated);
    } else {
        state.value.course.screens[screenIndex].object[itemKey].splice(itemIndex, 1, updated);
    }
};

const getScreenItem = (sequence, itemIndex) => {
    if (!state.value.course) return;
    const screenIndex = state.value.course.screens.findIndex(screen => screen.sequence === sequence);
    if (screenIndex === -1) return;
    const screen = state.value.course.screens[screenIndex];
    const type = screen.type.name;
    const itemKey = getItemKeyByType(type);
    if (type === 'quiz') return screen.questions[itemIndex];
    if (!screen.object[itemKey]) return;
    return screen.object[itemKey][itemIndex];
};

const setScreenItemIndex = (itemIndex) => {
    state.value.activeItemIndex = itemIndex;
};

export default readonly({
    setCourse,
    setScreen,
    getScreenItem,
    setScreenItem,
    setScreenItemIndex,

    state
});
